import React, { Component, PropTypes } from 'react';
import {Link} from 'react-router';
import { connect } from 'react-redux';
import {GetInterfaceLang, getSpecialStats, getSpecialEvents, GetChatPerson, getOneSpecialEvents, deleteSpecialEvents, GetForingLang, getChatEventFilter} from '../../actions/index';
var date = require('date-and-time');
class ChatSpecial extends Component {
    static contextTypes = {
        router: PropTypes.object
    };
    constructor(props){
        super(props);
        this.renderTooltip = this.renderTooltip.bind(this);
        this.addEvent = this.addEvent.bind(this);
        this.editEvent = this.editEvent.bind(this);
        this.delEventOpenModal = this.delEventOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.delChatPerson = this.delChatPerson.bind(this);
        this.filterInput = this.filterInput.bind(this);
        this.renderSelectFilter = this.renderSelectFilter.bind(this);
    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        this.props.GetInterfaceLang(token);
        this.props.getSpecialStats(token);
        this.props.getSpecialEvents(token);
        this.props.GetChatPerson(token);
        this.props.GetForingLang(token);
    }
    componentDidMount(){
        $('[data-toggle="tooltip"]').tooltip();
        $('.selectpicker').selectpicker();
    }
    addEvent(){
        this.context.router.push('/chat/special/add');
    }
    renderTooltip(){
        let that = this;
        return this.props.lang.foring_lang.results.map((item)=>{
            return that.props.chat.special_event_stat.map((stat)=>{
                if(item.id == stat.flang){
                    let string = stat.translated+ ' / ' +stat.total;
                    return(
                        <p key={item.id} className="pull-left info-item" data-toggle="tooltip" data-placement="top" title={string} >{item.lang.name}</p>
                    )
                }
            });
        })
    }
    renderIcon =(item)=>{
        return item.map((code)=>{
            if(code.text != '<p><br></p>' && code.text != '') {
                return this.props.lang.foring_lang.results.map((lang) => {
                    if(lang.id == code.flang){
                        return <i>{lang.lang.code}</i>
                    }
                });
            }
        });
    }
    editEvent(id, item){
        this.context.router.push('/chat/special/edit/'+id+'/');
    }
    delEventOpenModal(id, item){
        let token = localStorage.getItem('id_token_admin');
        let that= this;
        $('#DelChatPerson').modal('show');
        $('#DelChatPerson').on('shown.bs.modal', function () {
            that.props.getOneSpecialEvents(id, token);
        });
    }
    delChatPerson(){
        let token = localStorage.getItem('id_token_admin');
        this.props.deleteSpecialEvents(this.props.chat.special_event_one.id, token).then((response)=>{
            if(response.payload.status == 204){
                this.closeModal();
                $('input[name="word"]').val('')
                this.props.getSpecialEvents(token);
                this.props.getSpecialStats(token);
            }
        });
    }
    closeModal(){
        $('#DelChatPerson').modal('hide');
        this.props.chat.special_event_one = {};
    }
    renderTable(){
        return this.props.chat.special_events.results.map((item, i)=>{
            let person_name;
            this.props.chat.personsList.results.forEach((person)=>{
                if(item.person == person.id){
                    person_name = person.name;
                }
            })
            return(
                <div key={item.id} className="white-block common-list chat-list clearfix">
                    <p>{i+1}</p>
                    <p className="common-item-with-tag">
                        <span onClick={this.editEvent.bind(this, item.id)}>{item.event_name}</span>
                        {this.props.lang.foring_lang && this.props.lang.foring_lang.results && this.props.lang.foring_lang.results > 0 ? this.renderIcon(item.translations) : ""}
                    </p>

                    <p>{date.format(new Date(item.date_from), 'DD.MM.YYYY hh:mm A')}</p>
                    <p>{date.format(new Date(item.date_to), 'DD.MM.YYYY hh:mm A')}</p>

                    <p>{person_name}</p>
                    <p className="pull-right">
                        <button type="button" onClick={this.editEvent.bind(this, item.id)}>
                            <span className="span glyphicon glyphicon-edit" aria-hidden="true" />
                        </button>
                        <button type="button" onClick={this.delEventOpenModal.bind(this, item.id)}>
                            <span className="span glyphicon glyphicon-trash" />
                        </button>
                    </p>
                </div>
            )
        })
    }
    filterInput(e){
        if(e.target.name == 'woblang'){
            $('select[name="wblang"]').val('selectDefault')
        }
        if(e.target.name == 'wblang'){
            $('select[name="woblang"]').val('selectDefault')
        }
        let token = localStorage.getItem('id_token_admin');
        let data = {
            event_name: $('input[name="word"]').val(),
            woflang: $('select[name="woblang"]').val() != 'selectDefault' ? $('select[name="woblang"]').val() : '',
            wflang: $('select[name="wblang"]').val() != 'selectDefault' ? $('select[name="wblang"]').val() : ''
        }

        this.props.getChatEventFilter(token, data);
        $('.selectpicker').selectpicker('refresh')
    }
    renderSelectFilter(id){
        this.props.lang.foring_lang.results.forEach((item)=>{
            if($('#'+id).find('option#'+item.id).length){
                return false
            }else{
                $('#'+id).append($('<option>', {
                    value: item.id,
                    text : item.lang.name,
                    id : item.id
                }));
            }
        });
        $('.selectpicker').selectpicker('refresh')
    }
    render() {
        return (
            <div>
                <div className="dashboard-wrapper">
                    <div className="dashboard-title clearfix">
                        <div className="pull-left">
                            <p className="dashboard-title">Chat for special events</p>
                            <p className="dashboard-text">Chat</p>
                        </div>
                        <div className="pull-right dashboard-title">
                            <button onClick={this.addEvent} type="button" className="btn btn-primary">
                                <span className="glyphicon glyphicon-plus" aria-hidden="true" />
                                Add chat box
                            </button>
                        </div>
                    </div>
                    <div>
                        <div className="col-md-12">
                            <div className="white-block ">
                                <div className="clearfix static-header-buttons">
                                    <p className="pull-left">Translate to</p>
                                    <div className="block-info-group">
                                        {this.props.lang.foring_lang && this.props.lang.foring_lang.results &&
                                        this.props.lang.foring_lang.results.length > 0 && this.props.chat.special_event_stat ?
                                            this.renderTooltip()
                                            : ""}
                                    </div>
                                </div>
                                <div className="separate-horizontal"> </div>
                                <div className="clearfix">
                                    <div className="col-md-6">
                                        <div className=" input-group search_block">
                                            <span className="input-group-addon glyphicon glyphicon-search" />
                                            <input type="search" name="word" className="form-control" placeholder="Search" onChange={this.filterInput}/>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="input-half pull-left mr20">
                                            <select className="selectpicker" name="woblang" id="Without" defaultValue="selectDefault" data-live-search="true" onChange={this.filterInput}>
                                                <option value="selectDefault">Without translation into</option>
                                                {this.props.lang.foring_lang.results && this.props.lang.interface_lang.results ? this.renderSelectFilter('Without') : ""}
                                            </select>
                                        </div>
                                        <div className="input-half pull-left">
                                            <select className="selectpicker" name="wblang" id="into" defaultValue="selectDefault" data-live-search="true" onChange={this.filterInput}>
                                                <option value="selectDefault">Translated into</option>
                                                {this.props.lang.foring_lang.results && this.props.lang.interface_lang.results ? this.renderSelectFilter('into') : ""}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.props.chat.special_events.results
                        && this.props.chat.personsList.results.length > 0
                        && this.props.chat.personsList.results
                        && this.props.chat.special_events.results.length > 0 ?
                            <div>
                                <div className="col-md-12">
                                    <div className="common-list chat-list clearfix">
                                        <p>#</p>
                                        <p>Name</p>
                                        <p>Start time</p>
                                        <p>Expiry time</p>
                                        <p>Person</p>
                                        <p className="pull-right">Option</p>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    {this.renderTable()}
                                </div>
                            </div>
                            :
                            <div className={this.props.chat.special_events.results
                            && this.props.chat.personsList.results.length > 0
                            && this.props.chat.personsList.results
                            && this.props.chat.special_events.results.length < 0 || $.isEmptyObject(this.props.chat.special_events) && $.isEmptyObject(this.props.chat.personsList) ? "for_preloader" : 'for_preloader dn'}>
                                <div className="preloader-wrapper big active">
                                    <div className="spinner-layer spinner-blue-only">
                                        <div className="circle-clipper left">
                                            <div className="circle" />
                                        </div>
                                        <div className="gap-patch">
                                            <div className="circle" />
                                        </div>
                                        <div className="circle-clipper right">
                                            <div className="circle" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {this.props.chat.special_events.results && this.props.chat.special_events.results.length === 0 &&<p className="noResults">No items result</p>}
                    </div>

                    <div className="modal fade" id="DelChatPerson" tabIndex="-1" role="dialog" aria-labelledby="DelChatPersonLabel">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" onClick={this.closeModal} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                </div>
                                <div className="modal-body text-center">
                                    <span className="glyphicon glyphicon-alert" aria-hidden="true" data-toggle="modal" data-target="#DelChatPerson" />
                                    <p>Do you really want to delete chat event {this.props.chat.special_event_one ? <span>{this.props.chat.special_event_one.event_name} </span> : ""}?</p>
                                </div>
                                <div className="modal-footer text-center">
                                    <button onClick={this.closeModal} type="button" className="btn btn-default">No</button>
                                    <button onClick={this.delChatPerson} type="button" className="btn btn-primary">Yes</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="clearfix"></div>
                </div>
            </div>

        );
    }
}
function  mapStateToProps(state) {
    return{
        lang: state.lang,
        chat: state.chat
    }
}

export default connect(mapStateToProps, {GetInterfaceLang, getSpecialStats, getSpecialEvents, GetChatPerson, getOneSpecialEvents, deleteSpecialEvents, GetForingLang, getChatEventFilter})(ChatSpecial);

// <div className="clearfix">
//                                     <div className="col-md-6 input-half pull-left">
//                                         <input type="search" className="form-control" placeholder="Search"/>
//                                     </div>
//                                     <div className="col-md-6 pull-right">
//                                         <div className="input-half pull-left mr20">
//                                             <select className="selectpicker" data-live-search="true">
//                                                 <option value="" selected disabled>Without translation into</option>
//                                                 <option>Yes</option>
//                                                 <option>No</option>
//                                             </select>
//                                         </div>
//                                         <div className="input-half pull-left">
//                                             <select className="selectpicker" data-live-search="true">
//                                                 <option value="" selected disabled>Translated into</option>
//                                                 <option>Yes</option>
//                                                 <option>No</option>
//                                             </select>
//                                         </div>
//                                     </div>
//                                 </div>


// WEBPACK FOOTER //
// ./src/components/chat/chatSpecial.js